import React from "react";
import { useScroll, useTransform, useReducedMotion } from "framer-motion";

// Scroll-linked parallax for a section's background decoration: moves from
// `range[0]` to `range[1]` as the target section travels through the
// viewport. Disabled (no motion) when the user prefers reduced motion.
export function useParallaxY<T extends HTMLElement>(ref: React.RefObject<T | null>, range: [number, number]) {
  const prefersReducedMotion = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  return useTransform(scrollYProgress, [0, 1], prefersReducedMotion ? [0, 0] : range);
}
